import { History } from 'history';
import * as React from 'react';
import { requestingHotels } from 'src/core/SmallComponent';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { makeid, scrollToTop } from '../core/index'; 
import { HotelBedCatalogData, HotelBedData } from '../shared/index';
import { getAjaxhelper, isNull } from '../utils/index';
import { RecieveHotelDetailDataControlManager } from './hotel-common-utils';
import { HotelListPanelWithBulkData } from './HotelListPanelWithBulkData';
import { REQ_AVAILABLE_PANEL_STATE } from './BaseHaveHotelSearchPanel';

const PAGE_SIZE = 15;

export interface HotelsMainContentWithBulkDataProps extends BaseComponentProps {
    lang: string;
    currency: string;
    history: History;
    initialFilter: HotelBedData.SearchFilter;
    wishlistCount: (c: number) => any;
    // statusCode?: 'REQUESTING' | 'AVAILABLE' | 'NOTAVAILABLE' | 'PARTIALY-AVAILABLE' | 'COMPLETE-WITH-ERROR';
    /**
     * data category di index
     */
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    responKey: string;
    specialPage?: boolean; 
    firebaseApp: firebase.app.App;
    updateMinMax: (min: number, max: number) => any;
    page: number;
}
export interface HotelsMainContentWithBulkDataState extends BaseComponentState {
    page: number;
    filter: string;
    count: number;
    displayed: number[];
    hotelCodes: number[];
    externalFilter?: HotelBedData.ExternalFilter;
    requesting: boolean;
    hotels: HotelBedData.PagedHotelbedData;
    panelState: REQ_AVAILABLE_PANEL_STATE;
    errorMessage?: string;  
    order: string;
    orderAsc: string;
}

export class HotelsMainContentWithBulkData extends BaseComponent<HotelsMainContentWithBulkDataProps, HotelsMainContentWithBulkDataState> {

    /**
     * manager revieve data hotel detail. untuk push data hotel detail
     */
    recieveHotelDetailDataControlManager: RecieveHotelDetailDataControlManager = new RecieveHotelDetailDataControlManager();

    constructor(props: HotelsMainContentWithBulkDataProps) {
        super(props);
        this.state = {
            page: props.page ? props.page : 0,
            filter: '',
            count: 15,
            displayed: this.generateRandomImageState(),
            hotelCodes: [],
            requesting: true,
            hotels: null!,
            panelState: "CHECKING_WITH_NO_DATA_READY",
            order: 'hbOrder', orderAsc: 'ASC'
        };
    }

    updatePanelState(panelState: REQ_AVAILABLE_PANEL_STATE) {
        this.setStateHelper(
            st => {
                st.panelState = panelState;
            }
        );
    }

    updateFilter(parameter: { hotelCodes?: number[], externalFilter?: HotelBedData.ExternalFilter }) {
        this.setStateHelperAsync(
            st => {
                st.hotelCodes = parameter.hotelCodes ? parameter.hotelCodes : [];
                st.externalFilter = parameter.externalFilter!;
                st.page = 0;
                st.requesting = true;
            }
        ).then(
            d => {
                this.getAvailabilityDetail("updateFilter");
            }
        );
    }

    componentDidUpdate(prevProps: HotelsMainContentWithBulkDataProps, prevState: HotelsMainContentWithBulkDataState) {
        if (prevProps.responKey !== this.props.responKey) {
            scrollToTop();
        } 
        if (this.state.page !== prevState.page) {
            scrollToTop();
        } 
    }

    randomImageDisplayed: (displayed: number[]) => number = (displayed: number[]) => {
        let run: number = Math.floor(Math.random() * 10);
        if (displayed.indexOf(run) >= 0) {
            return this.randomImageDisplayed(displayed);
        }
        displayed.push(run);
        return run;
    }

    generateRandomImageState(): number[] {
        let displayed: number[] = [];
        let retval: number[] = [];
        for (let i = 0; i < 10; i++) {
            retval.push(this.randomImageDisplayed(displayed));
        }
        return retval!;
    }

    renderHotels = () => {
        let hotels: any[] = [];
        let promoBannerDesktop = [
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Hotels.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Insurance.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Tours.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Transfer.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Villas.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Holidays.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Flights.jpg', hiperlink: true, url: 'https://flight.balihotelsandmore.com/' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/Charity.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/1-dolar-deposit.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/desktop/1808_BaliHotels_1920x745.jpg', hiperlink: true, url: 'https://www.insureandgo.com.au/affiliates/balihotelsandmore.jsp?affiliateid=464&promocode=bham&utm_source=balihotelsandmore&utm_medium=referral&utm_campaign=affiliate' }
        ];
        let promoBannerMobile = [
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/hotels-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/insurance-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/tours-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/transfers-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/villas-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/holidays-360-300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/flights-360-300px.jpg', hiperlink: true, url: 'https://flight.balihotelsandmore.com/' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/charity-360x300px.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/1-percent-deposit-mobile.jpg', hiperlink: false, url: '' },
            { img: 'https://storage.googleapis.com/bali-hotel-images/promo_banner/mobile/1808_BaliHotels_360x300.jpg', hiperlink: true, url: 'https://www.insureandgo.com.au/affiliates/balihotelsandmore.jsp?affiliateid=464&promocode=bham&utm_source=balihotelsandmore&utm_medium=referral&utm_campaign=affiliate' }
        ];
        // console.log(promoBannerMobile);
        if (!isNull(this.state.hotels) && !isNull(this.state.hotels.data)) {
            let lop = 0;
            let ran = 0;
            let lop2 = 0;
            this.state.hotels.data!.forEach(hotel => {
                let CurrencyConverter = hotel.CurrencyConverter;
                hotels.push(
                    <HotelListPanelWithBulkData
                        key={hotel.code}
                        hotelId={hotel.code!}
                        hotelData={hotel}
                        lang={this.props.lang}
                        history={this.props.history}
                        initialFilter={this.props.initialFilter}
                        wishlistCount={this.props.wishlistCount}
                        currency={this.props.currency}
                        CurrencyConverter={CurrencyConverter}
                        indexedCategoryData={this.props.indexedCategoryData}
                        recieveHotelDetailDataControlManager={this.recieveHotelDetailDataControlManager}
                        responKey={this.props.responKey}
                        firebaseApp={this.props.firebaseApp}
                    />
                );
                // ran = Math.floor(Math.random() * 10);

                if (lop % 4 === 0) {
                    ran = this.state.displayed[lop2];
                    lop2++;
                    if (promoBannerDesktop[ran].hiperlink === true) {
                        hotels.push(
                            <a key={makeid()} href={`${promoBannerDesktop[ran].url}`} target="_blank"><img className="desktop-only" src={promoBannerDesktop[ran].img} width='100%' style={{ marginBottom: 15, borderRadius: 5 }} /></a>
                        );
                        hotels.push(
                            <a key={makeid()} href={`${promoBannerDesktop[ran].url}`} target="_blank"><img className="mobile-only" src={promoBannerMobile[ran].img} width='100%' style={{ marginBottom: 15, borderRadius: 5 }} /></a>
                        );
                    } else {
                        hotels.push(
                            <img key={makeid()} className="desktop-only" src={promoBannerDesktop[ran].img} width='100%' style={{ marginBottom: 15, borderRadius: 5 }} />
                        );
                        hotels.push(
                            <img key={makeid()} className="mobile-only" src={promoBannerMobile[ran].img} width='100%' style={{ marginBottom: 15, borderRadius: 5 }} />
                        );
                    }

                }
                // this.displayed.push(ran);
                lop++;
            });
        }
        /*
        if (hotels.length !== 0) {
            hotels.push(<Pagination key='pagination' page={this.state.hotels.page!} pageSize={this.state.hotels.count!} totalCount={this.state.hotels.total!} onChangePage={this.onChangePage} />);
        }*/
        return hotels;
    }

    onChangePage: (page: number, pemanggil: string) => any = (page: number, pemanggil: string) => {
        this.setStateHelperAsync(
            st => {
                st.page = page;
                st.requesting = true;
            }
        ).then(
            d => {
                this.getAvailabilityDetail(pemanggil);
            }
        );
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }

        if (this.state.panelState === "ERROR") {
            return <h1>ERROR</h1>;
        } else if (this.state.panelState === "INITIAL_CHECKING" || this.state.panelState === "CHECKING_WITH_NO_DATA_READY" || this.state.requesting === true ) {
            return this.renderRequestingPanel();
        } 
        let specialBanner: any[] = [];
        if (this.props.specialPage) {
            specialBanner.push(<img src="https://storage.googleapis.com/bali-hotel-images/specials/bali%20hotels%20special%20offer.jpg" alt="bali hotels special offer" className="desktop-only" width="100%" />);
            specialBanner.push(<img src="https://storage.googleapis.com/bali-hotel-images/specials/bali-hotels-special-offer.jpg" alt="bali hotels special offer" className="mobile-only" width="100%" />);
        }
        return (
            <div>
                {specialBanner} 
                {this.renderHotels()}
            </div>
        );
    }

    getAvailabilitysSorted(order: string, sortAsc: string) {
        this.setStateHelper(
            st => {
                st.order = order;
                st.orderAsc = sortAsc;
                st.page = 0;
            },
            () => {
                this.getAvailabilityDetail("dari di sortir");
            }
        );
    }

    getAvailabilityDetail(pemanggil: string) {
        let fil = {
            "reqKey": this.props.responKey,
            "rowCount": PAGE_SIZE,
            "page": this.props.page ? this.props.page : this.state.page,
            "hotelCodes": this.state.hotelCodes,
            currencyCode: this.props.currency,
            externalFilter: this.state.externalFilter ,
            order: this.state.order,
            orderAsc: this.state.orderAsc
        };
        if (this.state.externalFilter && this.state.externalFilter.maxRate === 0 && this.state.externalFilter.minRate === 0) {
            delete this.state.externalFilter.minRate;
            delete this.state.externalFilter.maxRate;
        }
        console.log("Dipanggil Dari ", pemanggil);
        getAjaxhelper().post('/dynamics/hb-api/hotels-availability-hotel-only', fil).then((d: any) => {
            try {
                // sessionStorage.setItem(SESSION_STORAGE_AVAILABILITY_FILTER, JSON.stringify(fil));
                // console.log("getAvailabolityDetail", d);
                this.setStateHelperAsync(st => {
                    st.requesting = false;
                    let hotels = {
                        count: PAGE_SIZE,
                        page: st.page,
                        total: d.count,
                        data: d.rows,
                        maxRate: d.maxRate,
                        minRate: d.minRate
                    };
                    /*
                    if (st.filterRateChange === false) {
                        st.filterRateChange = true;
                        st.filterRate = {
                            maxRate: d.maxRate,
                            minRate: d.minRate
                        };
                    }*/
                    // console.log(hotels);
                    st.hotels = hotels;
                    //  st.leftPanelRequesting = 'lefpanelRequestComplate';
                    st.externalFilter = {
                        maxRate: d.maxRate,
                        minRate: d.minRate
                    };
                }).then(d2 => {
                    // this.props.updateMinMax(this.state.hotels.minRate!, this.state.hotels.minRate!);
                    // this.requestHotelDetailData();

                });
            } catch (exc) {
                this.setStateHelper(st => {
                    st.requesting = false;
                    st.panelState = 'ERROR';
                    st.errorMessage = `${exc.message}`;
                });
                console.log(exc);
            }
        }).catch((exc) => {
            console.error('error: ', exc);
        });
    }
 
    private renderRequestingPanel(): JSX.Element {
        if (this.state.panelState === 'CHECKING_WITH_NO_DATA_READY' || this.state.panelState === 'INITIAL_CHECKING') {
            return (
                <div>
                    {requestingHotels(15)}
                </div>
            );
        }
        return <input type='hidden' key='requsting_spacer' id='requsting_spacer' />;

    }
}



// WEBPACK FOOTER //
// ./src/hotels/HotelsMainContentWithBulkData.tsx